import { AssetStatus } from "@/v1/components/pages/GameDetail/components/AssetsTab/utils/constants";

import { MAX_CONCURRENT_UPLOADS } from "./constants";
import { getAssetsByStatus } from "./getAssetsByStatus";
import { makeAssetRequest, MakeAssetRequestType } from "./makeAssetRequest";

export const catchAssetRequest: MakeAssetRequestType = async (asset, request, state, options) => {
  const shouldUploadAsset =
    getAssetsByStatus(AssetStatus.IN_PROGRESS, state).length < MAX_CONCURRENT_UPLOADS;
  if (shouldUploadAsset) {
    await makeAssetRequest(asset, request, state, options);
  } else {
    state.waitingQueue.push([asset, request, options]);
  }
};
